import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase";

/** Reads only the natural pixel size, used for aspect-correct cropping. */
function readSize(file) {
    return new Promise((resolve, reject) => {
        const src = URL.createObjectURL(file);
        const probe = new Image();
        probe.onload = () => {
            URL.revokeObjectURL(src);
            resolve({ width: probe.naturalWidth, height: probe.naturalHeight });
        };
        probe.onerror = () => {
            URL.revokeObjectURL(src);
            reject(new Error(`Could not read image: ${file.name}`));
        };
        probe.src = src;
    });
}

/**
 * Uploads the original file untouched (no re-encoding) to Firebase Storage so
 * print output stays at full resolution and the saved proposal keeps working
 * after a reload - same upload pattern as material requests.
 */
export async function uploadImage(file) {
    const { width, height } = await readSize(file);
    const safeName = file.name.replace(/[^\w.-]+/g, "_").slice(-80);
    const storagePath = `artikaProposals/images/${Date.now()}-${Math.random().toString(36).slice(2, 8)}-${safeName}`;
    const fileRef = ref(storage, storagePath);
    await uploadBytes(fileRef, file, { contentType: file.type });
    const src = await getDownloadURL(fileRef);
    return { src, width, height, name: file.name, storagePath };
}

export function releaseImage(image) {
    if (image?.src.startsWith("blob:"))
        URL.revokeObjectURL(image.src);
}
